

/*setup*/
var markers,
    map,
    infoWin,
    bounds


/*onload*/
function initMap() {

    console.log('initMap');
    var mapOptions = {

        draggable: true,
        scrollwheel: false,
        scaleControl: true,
        panControl: false,
        zoomControl: true,
        mapTypeControl: false,
        streetViewControl: false,
        fullscreenControl: false,
        styles: [{featureType:"landscape",stylers:[{hue:"#FFA800"},{saturation:0},{lightness:0},{gamma:1}]},{featureType:"road.highway",stylers:[{hue:"#53FF00"},{saturation:-73},{lightness:40},{gamma:1}]},{featureType:"road.arterial",stylers:[{hue:"#FBFF00"},{saturation:0},{lightness:0},{gamma:1}]},{featureType:"road.local",stylers:[{hue:"#00FFFD"},{saturation:0},{lightness:30},{gamma:1}]},{featureType:"water",stylers:[{hue:"#00BFFF"},{saturation:6},{lightness:8},{gamma:1}]},{featureType:"poi",stylers:[{hue:"#679714"},{saturation:33.4},{lightness:-25.4},{gamma:1}]}]

    };

    map = new google.maps.Map(document.getElementById('googlemap'), mapOptions);
    infoWin = new google.maps.InfoWindow();

    var pointer = {
        url: "/theme/public/assets/images/logo/pecker_shadow.svg",
        anchor: new google.maps.Point(1,1),
        scaledSize: new google.maps.Size(30,45)
    }

    bounds = new google.maps.LatLngBounds();

    markers = locations.map(function(reference) {
        var marker = new google.maps.Marker({
            position: new google.maps.LatLng(reference.location_geo.split(",")[0], reference.location_geo.split(",")[1]),
            icon: pointer,
            map: map,
        });
        bounds.extend(marker.position);
        google.maps.event.addListener(marker, 'mouseover', function(evt) {
            infoWindowShow(evt,reference,marker);
        });
        google.maps.event.addListener(marker, 'click', function(evt) {
            markerClick(evt,reference,marker);
        });
        google.maps.event.addListener(map, 'zoom_changed', function(evt) {
            infoWin.close();
        });
        google.maps.event.addListener(map, 'click', function(evt) {
            infoWin.close();
        });
        return marker;
    });

    map.fitBounds(bounds);
    map.panToBounds(bounds);

}



function infoWindowShow(evt,reference,marker){
    infoWin.setContent('<div class="infobox"><b><a href="'+reference.location_url+'">'+reference.location_productname+'</a></b><br/>'+reference.location_address_street+' '+reference.location_address_number+', '+reference.location_address_zip+' '+reference.location_address_city+'<br/><img src="'+reference.location_image+'"/></div>');
    infoWin.open(map, marker);
    $('.gm-style-iw').parent().addClass('boxparent');
    $('.gm-style-iw').prev().hide();
    $('.gm-style-iw').next().hide();
}




function markerClick(evt,reference,marker){
    location.href=reference.location_url;
}





